import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-viewer',
  templateUrl: 'viewer.component.html'
})
export class ViewerComponent {
  @Input() item: any;
}
